// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `


.History_close__62Qmt {
    position: absolute;
    top: 10px;
    right: 10px;
    cursor: pointer;
}

@keyframes History_fadeIn__KFZB6 {
    from {
        opacity: 0;
        transform: translateY(-200px);
    }
    to {
        opacity: 1;
        transform: translateY(0);
    }
}
.History_bg_LoginForm__Mu\\+FV{
    min-height: 100svh;
    overflow: auto;

}

/* Design the webpage */
.History_contentFormLogin__AG7Iq{

}
.History_icon_copy__7vPqr{
    font-size: 20px;
    color:green;
    cursor: pointer;
}
/* Basic structure of login form */
.History_model_box__4xjGu{

    min-width: 300px;
    min-height:300px;
    position: relative;
    display: flex;
    flex-direction: column;
    gap:20px;
    /*height: 520px;*/

    padding: 50px 35px;
    background: linear-gradient(0deg, #000, #272727);
    animation: History_fadeIn__KFZB6 0.5s ease; /* Анимация появления */

    box-sizing: border-box;

    border-radius: 10px;
}
.History_buttonAccept__3jOKW{

    display: flex;
    justify-content: center;
    margin:0 auto;
}
/*.reg{*/
/*  height:400px !important;*/
/*}*/
/*.model_box form:before, .model_box form:after{*/
/*  content: '';*/
/*  position: absolute;*/
/*  left: -2px;*/
/*  top: -2px;*/
/*  background: linear-gradient(45deg, #fb0094, #0000ff, #00ff00,#ffff00, #ff0000, #fb0094,*/
/*  #0000ff, #00ff00,#ffff00, #ff0000);*/
/*  border-radius: 10px;*/
/*  background-size: 400%;*/
/*  width: calc(100% + 4px);*/
/*  height: calc(100% + 4px);*/
/*  z-index: -1;*/
/*  animation: steam 20s linear infinite;*/
/*}*/


form *{
    font-family: 'Poppins',sans-serif;
    color: #ffffff;
    letter-spacing: 0.5px;
    outline: none;
    border: none;
}

.History_bg_LoginForm__Mu\\+FV{
    min-height: 100svh;
    overflow: auto;

}

/* Design the webpage */
.History_contentFormLogin__AG7Iq{
    font-family: sans-serif;
    display: flex;
    align-items: center;
    justify-content: center;
}
/* Basic structure of login form */
.History_model_box__4xjGu{


    position: relative;
    display: flex;
    flex-direction: column;
    /*height: 520px;*/

    padding: 50px 35px;
    background: linear-gradient(rgb(3 47 18) 0%, rgb(87 218 177) 100%);
    box-sizing: border-box;

    border-radius: 10px;
}
/*.reg{*/
/*  height:400px !important;*/
/*}*/
/*.model_box form:before, .model_box form:after{*/
/*  content: '';*/
/*  position: absolute;*/
/*  left: -2px;*/
/*  top: -2px;*/
/*  background: linear-gradient(45deg, #fb0094, #0000ff, #00ff00,#ffff00, #ff0000, #fb0094,*/
/*  #0000ff, #00ff00,#ffff00, #ff0000);*/
/*  border-radius: 10px;*/
/*  background-size: 400%;*/
/*  width: calc(100% + 4px);*/
/*  height: calc(100% + 4px);*/
/*  z-index: -1;*/
/*  animation: steam 20s linear infinite;*/
/*}*/


form *{
    font-family: 'Poppins',sans-serif;
    color: #ffffff;
    letter-spacing: 0.5px;
    outline: none;
    border: none;
}

@keyframes History_steam__kmnMH {
    0% {
        background-position: 0 0;
    }
    50% {
        background-position: 400% 0;
    }
    100% {
        background-position: 0 0;
    }
}





.History_linksBlock__oM0ks{
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap:1rem;
    height: 50px;
    background-color: rgba(255,255,255,0.07);
    border-radius: 3px;
    padding: 0 10px;
    font-size: 14px;
    font-weight: 300;
    cursor: pointer;
    box-sizing: border-box; /* Добавляем box-sizing со значением border-box */

}
.History_password__cy2pT{
    color:#fff;
    margin-bottom: 30px;
}



`, "",{"version":3,"sources":["webpack://./src/Pages/Auction/components/History/History.module.css"],"names":[],"mappings":";;;AAGA;IACI,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,eAAe;AACnB;;AAEA;IACI;QACI,UAAU;QACV,6BAA6B;IACjC;IACA;QACI,UAAU;QACV,wBAAwB;IAC5B;AACJ;AACA;IACI,kBAAkB;IAClB,cAAc;;AAElB;;AAEA,uBAAuB;AACvB;;AAEA;AACA;IACI,eAAe;IACf,WAAW;IACX,eAAe;AACnB;AACA,kCAAkC;AAClC;;IAEI,gBAAgB;IAChB,gBAAgB;IAChB,kBAAkB;IAClB,aAAa;IACb,sBAAsB;IACtB,QAAQ;IACR,iBAAiB;;IAEjB,kBAAkB;IAClB,gDAAgD;IAChD,0CAA2B,EAAE,uBAAuB;;IAEpD,sBAAsB;;IAEtB,mBAAmB;AACvB;AACA;;IAEI,aAAa;IACb,uBAAuB;IACvB,aAAa;AACjB;AACA,QAAQ;AACR,6BAA6B;AAC7B,IAAI;AACJ,iDAAiD;AACjD,iBAAiB;AACjB,wBAAwB;AACxB,gBAAgB;AAChB,eAAe;AACf,4FAA4F;AAC5F,wCAAwC;AACxC,yBAAyB;AACzB,2BAA2B;AAC3B,6BAA6B;AAC7B,8BAA8B;AAC9B,iBAAiB;AACjB,0CAA0C;AAC1C,IAAI;;;AAGJ;IACI,iCAAiC;IACjC,cAAc;IACd,qBAAqB;IACrB,aAAa;IACb,YAAY;AAChB;;AAEA;IACI,kBAAkB;IAClB,cAAc;;AAElB;;AAEA,uBAAuB;AACvB;IACI,uBAAuB;IACvB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;AACA,kCAAkC;AAClC;;;IAGI,kBAAkB;IAClB,aAAa;IACb,sBAAsB;IACtB,iBAAiB;;IAEjB,kBAAkB;IAClB,kEAAkE;IAClE,sBAAsB;;IAEtB,mBAAmB;AACvB;AACA,QAAQ;AACR,6BAA6B;AAC7B,IAAI;AACJ,iDAAiD;AACjD,iBAAiB;AACjB,wBAAwB;AACxB,gBAAgB;AAChB,eAAe;AACf,4FAA4F;AAC5F,wCAAwC;AACxC,yBAAyB;AACzB,2BAA2B;AAC3B,6BAA6B;AAC7B,8BAA8B;AAC9B,iBAAiB;AACjB,0CAA0C;AAC1C,IAAI;;;AAGJ;IACI,iCAAiC;IACjC,cAAc;IACd,qBAAqB;IACrB,aAAa;IACb,YAAY;AAChB;;AAEA;IACI;QACI,wBAAwB;IAC5B;IACA;QACI,2BAA2B;IAC/B;IACA;QACI,wBAAwB;IAC5B;AACJ;;;;;;AAMA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,QAAQ;IACR,YAAY;IACZ,wCAAwC;IACxC,kBAAkB;IAClB,eAAe;IACf,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,sBAAsB,EAAE,iDAAiD;;AAE7E;AACA;IACI,UAAU;IACV,mBAAmB;AACvB","sourcesContent":["\n\n\n.close {\n    position: absolute;\n    top: 10px;\n    right: 10px;\n    cursor: pointer;\n}\n\n@keyframes fadeIn {\n    from {\n        opacity: 0;\n        transform: translateY(-200px);\n    }\n    to {\n        opacity: 1;\n        transform: translateY(0);\n    }\n}\n.bg_LoginForm{\n    min-height: 100svh;\n    overflow: auto;\n\n}\n\n/* Design the webpage */\n.contentFormLogin{\n\n}\n.icon_copy{\n    font-size: 20px;\n    color:green;\n    cursor: pointer;\n}\n/* Basic structure of login form */\n.model_box{\n\n    min-width: 300px;\n    min-height:300px;\n    position: relative;\n    display: flex;\n    flex-direction: column;\n    gap:20px;\n    /*height: 520px;*/\n\n    padding: 50px 35px;\n    background: linear-gradient(0deg, #000, #272727);\n    animation: fadeIn 0.5s ease; /* Анимация появления */\n\n    box-sizing: border-box;\n\n    border-radius: 10px;\n}\n.buttonAccept{\n\n    display: flex;\n    justify-content: center;\n    margin:0 auto;\n}\n/*.reg{*/\n/*  height:400px !important;*/\n/*}*/\n/*.model_box form:before, .model_box form:after{*/\n/*  content: '';*/\n/*  position: absolute;*/\n/*  left: -2px;*/\n/*  top: -2px;*/\n/*  background: linear-gradient(45deg, #fb0094, #0000ff, #00ff00,#ffff00, #ff0000, #fb0094,*/\n/*  #0000ff, #00ff00,#ffff00, #ff0000);*/\n/*  border-radius: 10px;*/\n/*  background-size: 400%;*/\n/*  width: calc(100% + 4px);*/\n/*  height: calc(100% + 4px);*/\n/*  z-index: -1;*/\n/*  animation: steam 20s linear infinite;*/\n/*}*/\n\n\nform *{\n    font-family: 'Poppins',sans-serif;\n    color: #ffffff;\n    letter-spacing: 0.5px;\n    outline: none;\n    border: none;\n}\n\n.bg_LoginForm{\n    min-height: 100svh;\n    overflow: auto;\n\n}\n\n/* Design the webpage */\n.contentFormLogin{\n    font-family: sans-serif;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n/* Basic structure of login form */\n.model_box{\n\n\n    position: relative;\n    display: flex;\n    flex-direction: column;\n    /*height: 520px;*/\n\n    padding: 50px 35px;\n    background: linear-gradient(rgb(3 47 18) 0%, rgb(87 218 177) 100%);\n    box-sizing: border-box;\n\n    border-radius: 10px;\n}\n/*.reg{*/\n/*  height:400px !important;*/\n/*}*/\n/*.model_box form:before, .model_box form:after{*/\n/*  content: '';*/\n/*  position: absolute;*/\n/*  left: -2px;*/\n/*  top: -2px;*/\n/*  background: linear-gradient(45deg, #fb0094, #0000ff, #00ff00,#ffff00, #ff0000, #fb0094,*/\n/*  #0000ff, #00ff00,#ffff00, #ff0000);*/\n/*  border-radius: 10px;*/\n/*  background-size: 400%;*/\n/*  width: calc(100% + 4px);*/\n/*  height: calc(100% + 4px);*/\n/*  z-index: -1;*/\n/*  animation: steam 20s linear infinite;*/\n/*}*/\n\n\nform *{\n    font-family: 'Poppins',sans-serif;\n    color: #ffffff;\n    letter-spacing: 0.5px;\n    outline: none;\n    border: none;\n}\n\n@keyframes steam {\n    0% {\n        background-position: 0 0;\n    }\n    50% {\n        background-position: 400% 0;\n    }\n    100% {\n        background-position: 0 0;\n    }\n}\n\n\n\n\n\n.linksBlock{\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    gap:1rem;\n    height: 50px;\n    background-color: rgba(255,255,255,0.07);\n    border-radius: 3px;\n    padding: 0 10px;\n    font-size: 14px;\n    font-weight: 300;\n    cursor: pointer;\n    box-sizing: border-box; /* Добавляем box-sizing со значением border-box */\n\n}\n.password{\n    color:#fff;\n    margin-bottom: 30px;\n}\n\n\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"close": `History_close__62Qmt`,
	"bg_LoginForm": `History_bg_LoginForm__Mu+FV`,
	"contentFormLogin": `History_contentFormLogin__AG7Iq`,
	"icon_copy": `History_icon_copy__7vPqr`,
	"model_box": `History_model_box__4xjGu`,
	"fadeIn": `History_fadeIn__KFZB6`,
	"buttonAccept": `History_buttonAccept__3jOKW`,
	"linksBlock": `History_linksBlock__oM0ks`,
	"password": `History_password__cy2pT`,
	"steam": `History_steam__kmnMH`
};
export default ___CSS_LOADER_EXPORT___;
